module.exports = __webpack_public_path__ + "static/img/dDR1.b424473c.png";